import React, { useMemo } from 'react';
import { Field } from 'formik';
import Select from '../../../../../../../../FormikFields/ComplexSelect/Select';
import { makeStyles } from '@material-ui/core';
import { getAllIndexes } from '../../../../../../../helpers';

const useStyles = makeStyles((theme) => ({
  selector: {
    width: '100%',
    height: 44,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#dfe3e7',
    },
  },
  tableItem: {
    padding: '14px 0',
  },
}));

const styles = {
  activitiesErrorStyle: {
    position: 'absolute',
    marginLeft: 14,
  },
};

const CptCodeComponent = (props) => {
  const classes = useStyles();
  const {
    row: { index: i },
    cptCodes,
    backendErrors,
    updateFieldValue,
    validateField,
    values = [],
  } = props;
  const index = parseInt(i);

  const onDataChange = async (dataKey, value, field, form) => {
    const prewValue = field.value;
    await form.setFieldValue(`ispConfiguration.services[${index}].cptCode`, value);
    await updateValidation(prewValue, form);
    updateFieldValue(index, 'cptCode', value);
  };

  const updateValidation = async (prewValue, form) => {
    await validateField(`ispConfiguration.services[${index}].cptCode`);
    if (backendErrors && backendErrors[index] && backendErrors[index].cptCode && backendErrors[index].cptCode === 'CPT Code should be unique') {
      const indexesOfSameCptCode = getAllIndexes(form.values.ispConfiguration.services.map(i => i.cptCode), prewValue);
      if (indexesOfSameCptCode.length === 2 && indexesOfSameCptCode.includes(index) || indexesOfSameCptCode.length === 1) {
        for (const i of indexesOfSameCptCode) {
          if (index !== i) {
            await validateField(`ispConfiguration.services[${i}].cptCode`);
          }
        }
      }
    }
  };

  const errors = useMemo(
    () => (backendErrors &&
      backendErrors[index] &&
      backendErrors[index].cptCode
    ),
    [backendErrors],
  );

  function validate(value) {
    if (values.map(({cptCode}, i) => i === index ? value : cptCode).count(value) > 1 ) {
      return 'CPT Code should be unique';
    }
  }

  return <div className={classes.tableItem}>
    <Field type={'select'} name={`ispConfiguration.services[${index}].cptCode`} validate={validate}>
      {({ field, form }) => {
        const allExisted = cptCodes?.map(({value}) => value) || [];
        const allSelected = form?.values?.ispConfiguration?.services?.map(({ cptCode }) => cptCode) || [];
        const disabledItems =  allExisted?.filter(i => allSelected.includes(i))
        return <Select
          name={`ispConfiguration.services[${index}].cptCode`}
          required={true}
          dataKey='code'
          filterValue={field.value}
          disableUnderline
          placeholder={'CPT code'}
          autoComplete='off'
          InputProps={{
            classes: {
              root: classes.selector,
            },
          }}
          disabledItems={disabledItems}
          className={classes.selector}
          activitiesErrorStyle={styles.activitiesErrorStyle}
          columnData={{
            isFilterable: true,
            options: (cptCodes || []),
          }}
          onChange={(dataKey, value) => onDataChange(dataKey, value, field, form)}
          error={errors || (form?.errors?.ispConfiguration?.services && form?.errors?.ispConfiguration?.services[index]?.cptCode)}
        />;
      }}
    </Field>
  </div>;
};

export default CptCodeComponent;

Object.defineProperties(Array.prototype, {
  count: {
    value: function(value) {
      return this.filter(x => x === value).length;
    }
  }
});
